import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from '@app/reducers';
import { CrudService, IApplicationResponse, LoggedInUserModel, ModulesBasedApiSuffix, prepareRequiredHttpParams, RxjsService, setRequiredValidator, WINDOW_CLOSE, fileUrlDownload, ResponseMessageTypes, SnackbarService, scrollToSectionInScrollableContainer } from '@app/shared';
import { MomentService } from '@app/shared/services/moment.service';
import { loggedInUserData } from '@modules/others';
import { SalesModuleApiSuffixModels } from '@modules/sales/shared/utils';
import { Store } from '@ngrx/store';
import { ScrollPanel } from 'primeng/scrollpanel';
import { combineLatest } from 'rxjs';
@Component({
  selector: 'upsell-quotation-acceptance-component',
  templateUrl: './upsell-accept-quotation.component.html',
  styleUrls: ['./remote-acceptance.component.scss']
})

export class UpsellQuotationAcceptanceComponent {
  constructor(private rxjsService: RxjsService, private momentService: MomentService, private sanitizer: DomSanitizer,
    private activatedRoute: ActivatedRoute, private store: Store<AppState>, private formBuilder: FormBuilder, private crudService: CrudService, private snackbarService: SnackbarService) {
  }
  quotationVersionId = "";
  showLoader = false;
  showButtons = true;
  callMeBack = false;
  acceptQuote = false
  decline = false;
  priceObjection = true;
  selected = true;
  quoteDetails: any = {};
  callBackForm: FormGroup;
  acceptForm: FormGroup;
  declineForm: FormGroup;
  loggedInUserData: LoggedInUserModel;
  todayDate = new Date();
  isAppointment = false;
  motivations = [];
  newsLetterTypes = [];
  enableButton = false;
  // captchaToken = '';
  // siteKey = '6LfrWVMcAAAAAAEa-uVB4qcXreBIa4wUeosfJwpT';
  siteKey = '6Ld2Fv0sAAAAABmslejvUyhBHI3MZHsARQCF9S5i';
  //terms and condition dialog
  IsInstallationDebtor = false;
  contractTermsandConditions = [];
  parseHtml: any;
  isAcceptTermsAndConditionsBtnDisabled = true;
  isAcceptTermsandConditions = false;
  isContractBtnDisabled = true;
  selectedTermsAndConditions = [];
  @ViewChild('scrollPanel', { static: false }) scrollPanel: ScrollPanel;

  ngOnInit(): void {
    this.combineLatestNgrxStoreData();
    this.createCallBackForm();
    this.createAcceptForm();
    this.createDeclineForm();
    this.callBackForm.patchValue(this.quoteDetails);
    this.acceptForm.patchValue(this.quoteDetails);
    this.declineForm.patchValue(this.quoteDetails);
  }

  // showResponse(response) {
  //   if (response) {
  //     this.captchaToken = response?.response;
  //   }
  // }

  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(loggedInUserData), this.activatedRoute.queryParams]
    ).subscribe((response) => {
      this.loggedInUserData = new LoggedInUserModel(response[0]);
      this.quotationVersionId = response[1]?.quotationVersionId;
      this.getDetailsById();
    });
  }

  radioChange(e) {
    if (e.value) {
      this.priceObjection = true;
      this.declineForm.controls['competitorName'].setValidators([Validators.required]);
      this.declineForm.controls['outComeReasonId'].setValidators([Validators.required]);
      this.declineForm.controls['isCustomerNotBuyFromCompetitor'].setValue(false);
      this.declineForm.updateValueAndValidity();
    } else {
      this.priceObjection = false;
      this.declineForm.controls['competitorName'].setValue(null);
      this.declineForm.controls['competitorName'].clearValidators();
      this.declineForm.controls['competitorName'].updateValueAndValidity();
      this.declineForm.controls['outComeReasonId'].setValue('');
      this.declineForm.controls['outComeReasonId'].clearValidators();
      this.declineForm.controls['outComeReasonId'].clearAsyncValidators();
      this.declineForm.controls['outComeReasonId'].updateValueAndValidity();
      this.declineForm.controls['isCustomerNotBuyFromCompetitor'].setValue(true);
      this.declineForm.updateValueAndValidity();
    }
  }

  screenChange(e) {
    this.rxjsService.setFormChangeDetectionProperty(true);
    if (e === 'callMeBack') {
      this.callMeBack = true
      this.acceptQuote = false;
      this.decline = false;
    } else if (e === 'accept') {
      this.acceptQuote = true;
      this.decline = false;
      this.callMeBack = false;
      this.getContractTermsAndConditions();
    } else {
      this.getMotivation();
      this.getNewsLetterTypes();
      this.decline = true;
      this.callMeBack = false;
      this.acceptQuote = false;
    }
  }

  getDetailsById() {
    this.crudService.get(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.UPSELL_QUOTE_ACCEPTANCE_DETAILS,
      undefined, false, prepareRequiredHttpParams({
        directSaleQuotationVersionId: this.quotationVersionId
      }))
      .subscribe(resp => {
        if (resp.isSuccess && resp.resources && resp.statusCode === 200) {
          this.quoteDetails = resp.resources;
          this.callBackForm.patchValue(this.quoteDetails);
          this.acceptForm.patchValue(this.quoteDetails);
          this.declineForm.patchValue(this.quoteDetails);
        }
      });
  }

  getMotivation() {
    this.crudService.get(
      ModulesBasedApiSuffix.SALES,
      SalesModuleApiSuffixModels.SALES_API_UX_MOTIVATION_REASON,
      undefined,
      false,
      null).subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode === 200) {
          this.motivations = response.resources;
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
  }

  getNewsLetterTypes() {
    this.crudService.get(
      ModulesBasedApiSuffix.SALES,
      SalesModuleApiSuffixModels.SALES_API_UX_NEWS_LETTER_TYPES,
      undefined,
      false,
      null).subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode === 200) {
          this.newsLetterTypes = response.resources;
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
  }

  createCallBackForm() {
    let callBackModel = {
      "isAppointment": false,
      "directSaleQuotationVersionId": "",
      "directSaleQuotationVersionNumber": "",
      "documentPath": "",
      "initialInstallationFee": 0,
      "customerId": "",
      "customerName": "",
      "mobile1": "",
      "mobile1CountryCode": "",
      "email": "",
      "createdUserId": "",
      "appointmentDate": "",
      "appointmentTimeFrom": "",
      "comments": ""
    }
    this.callBackForm = this.formBuilder.group({});
    Object.keys(callBackModel).forEach((key) => {
      this.callBackForm.addControl(key, (key == 'createdUserId' || key == 'modifiedUserId') ? new FormControl(this.loggedInUserData.userId) :
        new FormControl(callBackModel[key]));
    });
    this.callBackForm = setRequiredValidator(this.callBackForm, ["appointmentDate", "appointmentTimeFrom", "comments"]);
  }

  createAcceptForm() {
    let callBackModel = {
      "isAppointment": true,
      "directSaleQuotationVersionId": "",
      "directSaleQuotationVersionNumber": "",
      "documentPath": "",
      "initialInstallationFee": 0,
      "customerId": "",
      "customerName": "",
      "mobile1": "",
      "mobile1CountryCode": "",
      "email": "",
      "createdUserId": "",
      // "appointmentDate": "",
      // "appointmentTimeFrom": "",
      // "comments": ""

    }
    this.acceptForm = this.formBuilder.group({});
    Object.keys(callBackModel).forEach((key) => {
      this.acceptForm.addControl(key, (key == 'createdUserId' || key == 'modifiedUserId') ? new FormControl(this.loggedInUserData.userId) :
        new FormControl(callBackModel[key]));
    });
    // this.acceptForm = setRequiredValidator(this.acceptForm, ["appointmentDate", "appointmentTimeFrom", "comments"]);
  }

  createDeclineForm() {
    let declineQuotationModel = {
      "directSaleQuotationOutcomeId": null,
      "directSaleQuotationVersionId": "",
      "outComeId": "",
      "isCustomerAcceptCompetitorOffer": true,
      "competitorName": "",
      "outComeReasonId": "",
      "isCustomerNotBuyFromCompetitor": false,
      "isInstallation": true,
      "isService": false,
      "promotionalOfferNewsLetterTypeId": "",
      "newsLetterTypeId": "",
      "comments": "",
      "customerCallbackId": null,
      "isBookAppointment": true,
      "isActive": true,
      "timingOfDeal": new Date(),
      "createdUserId": ""
    }

    this.declineForm = this.formBuilder.group({});
    Object.keys(declineQuotationModel).forEach((key) => {
      this.declineForm.addControl(key, (key == 'createdUserId' || key == 'modifiedUserId') ? new FormControl(this.loggedInUserData.userId) :
        new FormControl(declineQuotationModel[key]));
    });
    this.declineForm = setRequiredValidator(this.declineForm, ["competitorName", "outComeReasonId"]);
  }

  onSubmitCallBackForm() {
    if (this.callBackForm.invalid) {
      return;
    }
    let payload = this.callBackForm.value;
    payload.isAppointment = false;
    this.showLoader = true;
    payload.initialInstallationFee = this.quoteDetails.installationFee;
    payload['appointmentTimeFrom'] = this.momentService.convertTwelveToTwentyFourTime(payload.appointmentTimeFrom);
    // payload['g-recaptcha-response'] = this.captchaToken ? this.captchaToken : null;

    this.crudService.create(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.UPSELL_QUOTE_ACCEPT, payload)
      .subscribe(resp => {
        if (resp.isSuccess && resp.statusCode == 200) {
          WINDOW_CLOSE();
        }
        this.showLoader = false;
      });
  }

  onSubmitAcceptForm() {
    if (this.acceptForm.invalid) {
      return;
    }

    this.showLoader = true;
    let payload = this.acceptForm.getRawValue();
    payload.isAppointment = true
    payload.initialInstallationFee = this.quoteDetails.installationFee;
    // payload.appointmentTimeFrom = this.momentService.convertTwelveToTwentyFourTime(payload.appointmentTimeFrom);
    // payload['g-recaptcha-response'] = this.captchaToken ? this.captchaToken : null;

    this.crudService.create(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.UPSELL_QUOTE_ACCEPT, payload)
      .subscribe(resp => {
        if (resp.isSuccess && resp.statusCode == 200) {
          WINDOW_CLOSE();
        }
        this.showLoader = false;
      });
  }

  onSubmitdeclineForm() {
    if (this.declineForm.invalid) {
      return;
    }
    this.showLoader = true;
    let payload = this.declineForm.value
    // payload['g-recaptcha-response'] = this.captchaToken ? this.captchaToken : null;

    this.crudService.create(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.UPSELL_QUOTE_DECLINE, payload)
      .subscribe(resp => {
        if (resp.isSuccess && resp.statusCode == 200) {
          WINDOW_CLOSE();
        }
        this.showLoader = false;
      });
  }

  getFileName(filePath: string): string {
    if (!filePath) return 'download';
    const pathOnly = filePath.split('?')[0];
    return pathOnly.split('/').pop() || pathOnly.split('\\').pop() || 'download';
  }

  fileDownloadUrl(documentPath: string, documentName?: string, event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (documentPath) {
      const fileName = documentName && documentName.trim() ? documentName.trim() : this.getFileName(documentPath);
      fileUrlDownload(
        documentPath,
        fileName,
        false,
        this.crudService,
        this.rxjsService,
        true,
        'download'
      ).then(() => {
        // URL resolved after async blob API call
      }).catch(error => {
        console.error('Error opening document:', error);
        this.snackbarService.openSnackbar('Unable to open document', ResponseMessageTypes.ERROR);
      });
    }
  }

  //terms and condition dialog
  getContractTermsAndConditions() {
    this.crudService
      .get(
        ModulesBasedApiSuffix.SALES,
        SalesModuleApiSuffixModels.TECHNICAL_UPSELLING_TERMS_AND_CONDITIONS,
        undefined, false, null, 1
      )
      .subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode === 200 && response.resources) {
          // this.callIdNo = response.resources.callId;
          this.rxjsService.setPopupLoaderProperty(false);
          response.resources.technicalUpsellingTermsandConditions.forEach((contractTermsandConditions: any) => {
            contractTermsandConditions.isCheckboxDisabled = true;
            contractTermsandConditions.isTermsAndConditionsRead = false;
          })
          this.contractTermsandConditions = response.resources.technicalUpsellingTermsandConditions;
          this.contractTermsandConditions.forEach((contractTermsandCondition: any, index: number) => {
            if (index == 0) {
              this.selectedTermsAndConditions = contractTermsandCondition;
            }
            if (contractTermsandCondition.parentTermsandConditionId === null || !contractTermsandCondition.parentTermsandConditionId) {
              this.parseHtml = JSON.stringify(contractTermsandCondition.termsandConditionDescription);
              this.parseHtml = JSON.parse(this.parseHtml);
              // const cleanHtml = this.sanitizer.sanitize(SecurityContext.HTML, this.parseHtml) ?? '';
              // this.parseHtml = this.sanitizer.bypassSecurityTrustHtml(cleanHtml);
              //Added this line for click link is not working
              this.parseHtml = this.sanitizer.bypassSecurityTrustHtml(this.parseHtml);
            }
            contractTermsandCondition.isChecked = false;
          })
        }
        setTimeout(() => {
          this.rxjsService.setPopupLoaderProperty(false);
          this.rxjsService.setGlobalLoaderProperty(false);
        }, 500);
      });
  }

  onOpenTermsAndConditionsIndex(selectionTypeVia: string, index: number, contractTermsandCondition: any, anchor: string) {
    if (selectionTypeVia == 'link') {
      contractTermsandCondition.isCheckboxDisabled = contractTermsandCondition.isChecked ? true : false;
      contractTermsandCondition.isTermsAndConditionsRead = true;
    }
    else if (selectionTypeVia == 'checkbox') {
      contractTermsandCondition.isChecked = true;
      contractTermsandCondition.isCheckboxDisabled = true;
    }
    if (selectionTypeVia === 'link') {
      setTimeout(() => {
        const content = this.scrollPanel && this.scrollPanel.el.nativeElement
          .querySelector('.ui-scrollpanel-content') as HTMLElement;
        const heading = document.getElementById('termConditionsBody');
        if (content && heading) {
          const headingOffset = heading.getBoundingClientRect().top - content.getBoundingClientRect().top;
          if (Math.abs(headingOffset) > 24) {
            this.scrollPanel.scrollTop(content.scrollTop + headingOffset);
          }
        }
      }, 0);
    }
    scrollToSectionInScrollableContainer(anchor);
    this.onTermsAndConditionsClicked();
  }

  onTermsAndConditionsClicked(type?: string) {
    let tempArray: any = [];
    this.contractTermsandConditions.forEach((value: any, index) => {
      if (!value.parentTermsandConditionId || value.parentTermsandConditionId === null) {
        this.contractTermsandConditions.splice(index, 1);
      }
      tempArray = this.contractTermsandConditions;
    });
    this.isContractBtnDisabled = (tempArray.filter((ct: any) => !ct['isChecked']).length == 0 && this.isAcceptTermsandConditions &&
      tempArray.length > 0) ? false : true;
    this.isAcceptTermsAndConditionsBtnDisabled = this.contractTermsandConditions.filter(c => c['isChecked']).length !== this.contractTermsandConditions.length;
    if (type == 'final accept' && this.isAcceptTermsandConditions || type == undefined && this.isAcceptTermsandConditions) {
      this.isAcceptTermsAndConditionsBtnDisabled = true;
    }
  }
}
